import { makeStyles } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";

export const useStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[4],
  },
  description: {
    fontSize: designTokens.fontSize.sm,
    color: designTokens.neutral[600],
    lineHeight: String(designTokens.lineHeight.relaxed),
    margin: 0,
  },
  placementSection: {
    display: "flex",
    flexDirection: "column",
    paddingBottom: designTokens.spacing[4],
    borderBottom: `1px solid ${designTokens.neutral[200]}`,
    "& .fui-Radio + .fui-Radio": {
      marginTop: "-10px",
    },
  },
  placementLabel: {
    fontSize: designTokens.fontSize.sm,
    fontWeight: designTokens.fontWeight.semibold,
    color: designTokens.neutral[700],
  },
  checkboxGroup: {
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[1],
  },
  questionRow: {
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[1],
  },
  questionInput: {
    flexGrow: 1,
  },
  questionInputError: {
    outline: `1px solid ${designTokens.semantic.error}`,
    "&::after": {
      borderBottomColor: designTokens.semantic.error,
      borderBottomWidth: "2px",
    },
  },
});
